var _a, _b, _c;
const allowedEnvironmentValues = [
    'test-automation',
    'development',
    'staging',
    'production',
];
const testAutomation = import.meta.env.MODE === 'test' ? 'test-automation' : undefined;
const rawEnvironment = (_c = ((_b = (_a = import.meta.env.VITE_ENVIRONMENT) !== null && _a !== void 0 ? _a : testAutomation) !== null && _b !== void 0 ? _b : 'development')) === null || _c === void 0 ? void 0 : _c.trim().toLowerCase();
if (!rawEnvironment ||
    !allowedEnvironmentValues.includes(rawEnvironment || '')) {
    throw new Error(`Invalid environment value: ${import.meta.env.VITE_ENVIRONMENT}. Must be one of ${allowedEnvironmentValues.join(', ')}`);
}
export const ENVIRONMENT = rawEnvironment;
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'https://connect.staging.moovy.cloud';
